import CreateWindow from "../puzzleWindow";
import { html, render } from "lit-html";
import "./index.css";
import { tips } from "~/src/tips";
import { computerScreens } from "~src/helpers/computerScreens";
import { userChoiceTracker } from "../../helpers/userChoiceTracker";
import { exitButtonPosition } from "../../helpers/exitButtonPosition";
import kiikarit from "./img/kiikarit.jpg";
import savanni from "./img/savanni.jpg";
import spam from "./img/spam.png";
import restore from "./img/restore.png";
import { iOSallowScroll } from "../../helpers/iOSHacks";
import { textContents } from "../../textcontents";
import { unsafeHTML } from "lit-html/directives/unsafe-html";
const everythingCorrect = ({ notification, puzzleCode, ding }) => {
  userChoiceTracker.processAnswer(puzzleCode, true); // correct answer stored
  $("#activeMessage #newMail").removeClass("hide");
  $("#newemail").parent().parent().addClass("highlightmail")
  $("#activeMessage #mail1").addClass("hide");
  $("#spamButton").css("visibility", "hidden")
  // PIILOTA KAIKKI CHECKBOXATUT
  $(".mailspam:checkbox:checked").parent().parent().addClass("hide");
  $(".mailspam").parent().parent().addClass("hide");
  // PÄIVITÄ NÄKYVILLE JÄÄVÄN VIESTIN LISTANÄKYMÄ

  // POISTA SPAMMIVIESTIT JA NÄYTÄ AINOA AITO

  //PIILOTA KOKONAINEN VIESTI.
  //  $("#activeMessage").children().hide();
  // $("#activeMessage #" +$('.spamreport.original input[type="checkbox"]:not(:checked)').data("name")).show();

  /// HAE AIKA JA NÄYTÄ VIIVEELLÄ ILMOITUS SEKÄ UUSI VIESTI LISTASSA
  var aika = new Date($.now());
  $("#newMail .time").html(aika.getHours() + ":" + aika.getMinutes());
  setTimeout(
    function () {
      $("#newemail").parent().parent().removeClass("hide").addClass("bold");
      if (notification) {
        ding.play();
        $("#mailNotification").addClass("slide");

        $("#mailNotification").on("click", function () {
          $("#activeMessage").children().addClass("hide");
          $("#activeMessage #newMail").removeClass("hide");
          $(".message").removeClass("highlightmail");
          $(".spamreport.uusi")
            .parent()
            .addClass("highlightmail")
            .removeClass("bold");
          $("#mailNotification").removeClass("slide");
        });
      }
      userChoiceTracker.processAnswer(puzzleCode, true); // correct answer stored
      tips.solveFlatComputer.clear();
      tips.flatComputer.clear();
      tips.flatComputerWrong.clear();
      setTimeout(function () {
        $("#mailNotification").removeClass("slide");
      }, 10000);
    },
    notification ? 1000 : 0
  );
};

let wrongAnsweredEmail = false;
const FlatPuzzle = function () {
  if (!computerScreens.flat.availableToUse()) return null;
  const puzzleCode = "flatPuzzle2";
  var ding = new Audio("/sound/ding.mp3");
  const markup = html`
    <div class="email-container">
      <div id="parentEmailWrapper" class="">
        <div id="mailNotification">
          <div>
           ${textContents.email.notification.header}<br />
            <b>${textContents.email.notification.source}</b><br />
            ${textContents.email.notification.text}
          </div>
        </div>

        <div id="emailContainer">
          <div id="spamButton">
            <div class="emailnappi">
              <div><img src="${spam}" /></div>
              <div>${textContents.email.moveToTrash}</div>
              <div id="spamLaskuri">0/5</div>
            </div>
          </div>
          <div id="emailModal" class="modal hide">
            <div class="window">
              <div class="modalteksti"></div>
              <div class="emailmodalnappi modalnappi">OK</div>
            </div>
          </div>
          <div id="restoreButton" class="hide">
            <div class="emailnappi">
              <div><img src="${restore}" /></div>
              <div>${textContents.email.cancelAction}</div>
            </div>
          </div>

          <div id="messagesWrapper">
            <div class="message bold hide">
              <div class="spamreport uusi">
                <input
                  type="checkbox"
                  id="newemail"
                  name="newemail"
                  class="uusi"
                /><label for="newemail"></label>
              </div>
              <div class="name" data-name="newMail">${textContents.email.notification.source}</div>
              <div class="title" data-name="newMail">${textContents.email.notification.header}</div>
            </div>

            <div class="message bold">
              <div class="spamreport original">
                <input
                  type="checkbox"
                  data-name="mail1"
                  id="email1"
                  name="email1"
                  class="mail mailspam"
                /><label for="email1"></label>
              </div>
              <div class="name" data-name="mail1">
                marcjacksonjr85@bmail.com
              </div>
              <div class="title" data-name="mail1">${textContents.email.title1}</div>
            </div>

            <div class="message bold">
              <div class="spamreport original">
                <input
                  type="checkbox"
                  data-name="mail2"
                  id="email2"
                  name="email2"
                  class="mail aito"
                /><label for="email2"></label>
              </div>
              <div class="name" data-name="mail2">${textContents.email.shopName}</div>
              <div class="title" data-name="mail2">
               ${textContents.email.title2} 
              </div>
            </div>

            <div class="message bold">
              <div class="spamreport original">
                <input
                  type="checkbox"
                  data-name="mail3"
                  id="email3"
                  name="email3"
                  class="mail mailspam"
                /><label for="email3"></label>
              </div>
              <div class="name" data-name="mail3">parcelservice.inc</div>
              <div class="title" data-name="mail3">${textContents.email.title3}</div>
            </div>

            <div class="message bold">
              <div class="spamreport original">
                <input
                  type="checkbox"
                  data-name="mail4"
                  id="email4"
                  name="email4"
                  class="mail mailspam"
                /><label for="email4"></label>
              </div>
              <div class="name" data-name="mail4">bitcn7842smd@167.com</div>
              <div class="title" data-name="mail4">${textContents.email.title4}</div>
            </div>

            <div class="message bold">
              <div class="spamreport original">
                <input
                  type="checkbox"
                  data-name="mail5"
                  id="email5"
                  name="email5"
                  class="mail mailspam"
                /><label for="email5"></label>
              </div>
              <div class="name" data-name="mail5">info@next.xadeput.com</div>
              <div class="title" data-name="mail5">${textContents.email.title5}</div>
            </div>

            <div class="message bold">
              <div class="spamreport original">
                <input
                  type="checkbox"
                  data-name="mail6"
                  id="email6"
                  name="email6"
                  class="mail mailspam"
                /><label for="email6"></label>
              </div>
              <div class="name" data-name="mail6">Ho.Tuo@meg.fis.edu</div>
              <div class="title" data-name="mail6">${textContents.email.title6}</div>
            </div>

            <div id="activeMessage">
              <div id="mail1">
                <div class="name">
                  <b>Marc B. Jackson</b> &lt;marcjacksonjr85@bmail.com&gt;
                </div>
                <div class="title">${textContents.email.title1}</div>
                <div class="time">18:29</div>
                <div class="mailcontent">
                  <p>
                  ${textContents.email.mail1["1"]}
                  </p>
                  <p>
                  ${textContents.email.mail1["2"]}
                  </p>
                  <p>
                  ${unsafeHTML(textContents.email.mail1["3"])}
                  </p>
                </div>
              </div>

              <div id="mail2" class="hide">
                <div class="name">
                  <b>${textContents.email.shopName}</b>
                  &lt;${textContents.email.shopAddresss}&gt;
                </div>
                <div class="title">${textContents.email.title2}</div>
                <div class="time">15:43</div>
                <div class="mailcontent">
                  <p>${unsafeHTML(textContents.email.mail2["1"])}</p>
                  <p>
                  ${unsafeHTML(textContents.email.mail2["2"])}
                  </p>
                  <p>${unsafeHTML(textContents.email.mail2["3"])}</p>
                  <div class="juliste">
                    <img src="${kiikarit}" />
                  </div>
                  <p>
                  ${unsafeHTML(textContents.email.mail2["4"])}.
                  </p>

                  <p>
                  ${unsafeHTML(textContents.email.mail2["5"])}
                  </p>
                </div>
              </div>

              <div id="mail3" class="hide">
                <div class="name">&lt;parcelservice.inc&gt;</div>
                <div class="title">${textContents.email.title3}</div>
                <div class="time">14:11</div>
                <div class="mailcontent">
                  <p> ${unsafeHTML(textContents.email.mail3["1"])},</p>
                  <p>
                  ${unsafeHTML(textContents.email.mail3["2"])}.
                  </p>
                  ${unsafeHTML(textContents.email.mail3["3"])}
                  <div class="emailbutton pieni"><b>15508482258988</b></div>
                </div>
              </div>

              <div id="mail4" class="hide">
                <div class="name">&lt;bitcn7842smd@167.com&gt;</div>
                <div class="title">${textContents.email.title4}</div>
                <div class="time">13:31</div>
                <div class="mailcontent">
                  <p>${unsafeHTML(textContents.email.mail4["1"])}</p>
                  <p>
                  ${unsafeHTML(textContents.email.mail4["2"])}
                  </p>
                  <p>
                  ${unsafeHTML(textContents.email.mail4["3"])}
                  </p>
                  <div class="emailbutton"> ${unsafeHTML(textContents.email.mail4["4"])}</div>
                </div>
              </div>

              <div id="mail5" class="hide">
                <div class="name">&lt;info@next.xadeput.com&gt;</div>
                <div class="title">${textContents.email.title5}</div>
                <div class="time">12:01</div>
                <div class="mailcontent liila">
                  <p>
                  ${unsafeHTML(textContents.email.mail5["1"])}
                  </p>
                  <p> ${unsafeHTML(textContents.email.mail5["2"])}</p>
                  <div class="emailbutton"> ${unsafeHTML(textContents.email.mail5["3"])}</div>
                </div>
              </div>

              <div id="mail6" class="hide">
                <div class="name">&lt;Ho.Tuo@meg.fis.edu&gt;</div>
                <div class="title">${textContents.email.title6}</div>
                <div class="time">11:53</div>
                <div class="mailcontent">
                  <p>
                  ${unsafeHTML(textContents.email.mail6["1"])}
                  </p>
                </div>
              </div>

              <div id="newMail" class="hide">
                <div class="name">
                  <b>${textContents.email.notification.source}</b>
                  &lt;${textContents.email.notification.address}&gt;
                </div>
                <div class="title">${textContents.email.notification.title}</div>
                <div class="time">15:43</div>
                <div class="mailcontent">
                  <p> ${unsafeHTML(textContents.email.newMail1)}</p>
                  <p> ${unsafeHTML(textContents.email.newMail2)}</p>
                  <p> ${unsafeHTML(textContents.email.newMail3)}</p>
                  <div class="juliste">
                    <img src=${savanni} />
                  </div>

                  <p>
                    ${unsafeHTML(textContents.email.newMail4)}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  `;
  // CreateWindow palauttaa modaali-ikkunan noden, johon siis rendataan
  const puzzleWindow = CreateWindow({
    exitCallback: () => {
      if (!userChoiceTracker.retrieve()[puzzleCode] && !wrongAnsweredEmail) {
        tips.solveFlatComputer.setTime(5, { override: true });
      }

      if (!userChoiceTracker.retrieve()[puzzleCode] && !wrongAnsweredEmail) {
        tips.flatComputerWrong.setTime(0);
      }
      if (userChoiceTracker.retrieve()[puzzleCode]) {
        tips.safariPoster.setTime(30);
      }
    },
  }).element;

  tips.solveFlatComputer.setTime(40);
  render(markup, puzzleWindow);
  if(userChoiceTracker.retrieve()[puzzleCode]) {
    everythingCorrect({ notification: false, puzzleCode, ding });
  }
  exitButtonPosition();

  // EMAILIN KÄYTTÖLIITTYMÄN KILKKEET

  // LISÄÄ KOROSTUS LISTAUKSEN VALITTUIHIN
  $(".spamreport input:checkbox").on("change", function () {
    window.scene.getSoundByName("generalComputerSound")?.play();
    $('.spamreport input[type="checkbox"]:checked')
      .parent()
      .parent()
      .addClass("highlight");
    $('.spamreport input[type="checkbox"]:not(:checked)')
      .parent()
      .parent()
      .removeClass("highlight");
    $("#spamLaskuri").html(
      $('.spamreport input[type="checkbox"]:checked').length + "/5"
    );
  });

  //AVAA VIESTI KLIKKAAMALLA OTSIKKOA TAI LÄHETTÄJÄÄ JA LISÄÄ KOROSTUS
  $("#messagesWrapper .message .name, #messagesWrapper .message .title").on(
    "click",
    function () {
      $(".message").removeClass("highlightmail");
      $(this).parent().addClass("highlightmail");
      $(this).parent().removeClass("bold");

      // NÄYTÄ VARSINAINEN VIESTI
      $("#activeMessage").children().addClass("hide");
      $("#activeMessage #" + $(this).data("name")).removeClass("hide");
    }
  );

  // PIILOTA MODAL-ILMOITUS MODALIN OK-NAPISTA
  $(".emailmodalnappi").on("click", function () {
    window.scene.getSoundByName("generalComputerSound")?.play();
    $("#emailModal").hide();
  });

  // KUN SIIRRÄ-NAPPIA PAINAA...
  $("#spamButton .emailnappi").on("click", function () {
    window.scene.getSoundByName("generalComputerSound")?.play();
    var emailCheckboxesChecked = $('.spamreport input[type="checkbox"]:checked')
      .length;
    // TSEKKAA ONKO VALITTUJA VIISI
    if (emailCheckboxesChecked !== 5) {
      console.log("ALLE 5 VALITTU");
      $("#emailModal .window .modalteksti").html(
        textContents.email.error
        );
      $("#emailModal").show();
    } else {
      // TSEKKAA ONKO VALITUT SPAMMIÄ VAI EI
      if ($(".mailspam:checkbox:checked").length === 5) {
        everythingCorrect({ notification: true, puzzleCode, ding });
      } else {
        tips.solveFlatComputer.clear();
        tips.flatComputerWrong.setTime(15);
        wrongAnsweredEmail = true;
        // OIKEA MÄÄRÄ VIESTEJÄ, MUTTA HUIJAUSVIESTEJÄ EI OIKEA MÄÄRÄ
        userChoiceTracker.processAnswer(puzzleCode, false); // false answer stored
        console.log(
          "SPÄMMEJÄ EI OLE 5, VAAN " + $(".mailspam:checkbox:checked").length
        );
        // PIILOTA KAIKKI CHECKBOXATUT
        $(".mail:checkbox:checked").parent().parent().addClass("hide");
        // PÄIVITÄ NÄKYVILLE JÄÄVÄN VIESTIN LISTANÄKYMÄ
        $('.spamreport.original input[type="checkbox"]:not(:checked)')
          .parent()
          .parent()
          .removeClass("hide")
          .addClass("highlightmail")
          .removeClass("bold");

        // POISTA SPAMMIVIESTIT JA NÄYTÄ AINOA AITO
        //PIILOTA KOKONAINEN VIESTI
        //   $("#activeMessage").children().hide();
        //  $("#activeMessage #" +$('.spamreport.original input[type="checkbox"]:not(:checked)').data("name")).show();

        // VAIHDA YLÄREUNAN BUTTON
        $("#spamButton").addClass("hide");
        $("#restoreButton")
          .removeClass("hide")
          .on("click", function () {
            // NÄYTÄ KAIKKI VIESTIT, VAIHDA NAPIT

            window.scene.getSoundByName("generalComputerSound")?.play();
            $(".spamreport.original").parent().removeClass("hide highlight");
            $("#restoreButton").addClass("hide");
            $("#spamButton").removeClass("hide");
          });
      }

      // NÄYTÄ KOKO VIESTI
      $("#activeMessage").children().addClass("hide");
      $(
        "#activeMessage #" +
          $('.spamreport.original input[type="checkbox"]:not(:checked)').data(
            "name"
          )
      ).removeClass("hide");
    }
  });

  iOSallowScroll("#emailContainer");
};

export default FlatPuzzle;
